import { isNumber, isValidDate } from '@/utils'
import { useCallback } from 'react'
import { DateSelect } from '../DateSelect'
import { FormItem } from './Component'

type FormValue =
  | number
  | {
      month?: number
      year?: number
      date?: number
    }
  | undefined

type DateSelectValue =
  | {
      [key: string]: number
    }
  | undefined

// P
interface FormDateSelectProps {
  name: string
  label?: string
  initialValue?: number
  info?: string
  helperText?: string
  ignoreErrorKeys?: string[]
  [key: string]: any
}

const makeValue = (value: FormValue): DateSelectValue => {
  if (!value) return undefined

  const date = new Date(value as number)
  if (isNumber(value) && isValidDate(date)) {
    return {
      month: date.getMonth() + 1,
      year: date.getFullYear(),
      date: date.getDate(),
    }
  }

  return value as DateSelectValue
}

export const FormDateSelect = ({
  name,
  label,
  initialValue,
  info,
  helperText,
  ignoreErrorKeys,
  ...props
}: FormDateSelectProps) => {
  const Component = useCallback(
    ({
      onChange,
      value,
      ...field
    }: {
      onChange?: (value: FormValue) => void
      value?: FormValue
      [key: string]: any
    }) => {
      const handleOnChange = (dateValue: { [key: string]: number }) => {
        const { month, year, date } = dateValue
        if (month && year && date) {
          onChange?.(Date.parse(new Date(year, month - 1, date).toISOString()))
        } else {
          onChange?.(dateValue)
        }
      }

      return (
        <DateSelect
          onChange={handleOnChange}
          value={makeValue(value)}
          {...field}
          {...props}
          dateKey="date"
          monthKey="month"
          yearKey="year"
        />
      )
    },
    [],
  )

  return (
    <FormItem
      helperText={helperText}
      ignoreErrorKeys={ignoreErrorKeys}
      info={info}
      initialValue={initialValue}
      label={label}
      name={name}
    >
      <Component />
    </FormItem>
  )
}
